<template src="./EnvioDeMensajes.html"></template>
<script>
import metodos_comunes from "../../js/metodos_comunes";
import {
  consultarEstructuraFormulariosPorId
} from "../../apiService/request/CrudFormulario.js";
import { eliminarFormulariosExistentes } from "../../apiService/request/CrudFormulario";
import { serverBus } from "../../main";
import moment from "moment";
import DatePicker from "../DatePicker/Datepicker";
import { crearOrdenDesdeFormulario } from "../../apiService/request/CrudOrdenes";
import Vue from "vue";
import VueYoutube from "vue-youtube";
import SerieFormularios from "../SerieFormularios/SerieFormularios";
import {
  crearFormularioEnvioDeMensajes,
  consultarEstructuraFormularioEnvioDeMensajes,
  actualizarFormularioEnvioDeMensajes,
  enviarMensaje
} from "../../apiService/request/crudEnvioDeMensajes";
import Carrusel from "../Carrusel/Carrusel";

export default {
  data() {
    return {
      variabl: {},
      items: {},
      itemsPerPage: 1,
      page: 1,
      search: "",
      renderizar: 0,
      formularioEnviarMensaje: 0,
      cantidaElementosMostrar: 0,
      nombreFormulario: null,
      idFormulario: null,
      variablesFormulario: null,
      coleccion: null,
      arrayNumeros: [],
      valorVariable: 0,
      padding: "2% 3% 2% 3%",
      gridTemplate: "1fr 1fr 1fr",
      valid: false,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      variablesActualizadas: [],
      cargandoComponente: true,
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      },

      responsive: "embed-responsive-item",
      ancho: "100%",
      alto: "400",
      url: "https://www.youtube.com/embed/",
      video: "nkA-Tl4zv-E",
      borde: "0",
      pcompleta: null,
      tick_labels: "",
      ensayo: {
        status: 200,
        data: {
          variables: [
            {
              nombre: "Terapia",
              obligatorio: false,
              habilitado: true,
              variable: "variable1",
              valor: null,
              tipo: "lista",
              lista: "lista_terapia",
              opciones_lista: [
                {
                  valor: "Terapia 1",
                  puntaje: null
                },
                {
                  valor: "Terapia 2",
                  puntaje: null
                },
                {
                  valor: "Terapia 3",
                  puntaje: null
                }
              ]
            },
            {
              nombre: "Asunto del mensaje",
              obligatorio: false,
              habilitado: true,
              variable: "variable2",
              valor: null,
              tipo: "lista",
              lista: "lista_asunto",
              opciones_lista: [
                {
                  valor: "Asunto 1",
                  puntaje: null
                },
                {
                  valor: "Asunto 2",
                  puntaje: null
                },
                {
                  valor: "Asunto 3",
                  puntaje: null
                }
              ]
            },
            {
              nombre: "Archivo",
              obligatorio: false,
              habilitado: true,
              variable: "variable3",
              valor: null,
              tipo: "lista",
              lista: "lista_archivo",
              opciones_lista: [
                {
                  valor: "Imagen",
                  puntaje: null
                },
                {
                  valor: "Video",
                  puntaje: null
                },
                {
                  valor: "Documento",
                  puntaje: null
                }
              ]
            },
            {
              nombre: "Actividad",
              obligatorio: false,
              habilitado: false,
              variable: "variable4",
              tipo: "array_lista",
              valor: null,
              lista: "actividades",
              indexPadre: 2,
              opciones_lista: [
                {
                  valor: "Ejercicio de Brazo",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Video"
                    }
                  ]
                },
                {
                  valor: "Ejercicio de Pierna",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Video"
                    }
                  ]
                },
                {
                  valor: "Ejercicio de Torax",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Video"
                    }
                  ]
                },
                {
                  valor: "Respirar con la nariz",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Imagen"
                    }
                  ]
                },
                {
                  valor: "Respirar con el diafragma",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Imagen"
                    }
                  ]
                },
                {
                  valor: "Guía de estiramiento",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Documento"
                    }
                  ]
                },
                {
                  valor: "Guía de como respirar adecuadamente",
                  puntaje: null,
                  condiciones: [
                    {
                      lista: "lista_archivo",
                      valor: "Documento"
                    }
                  ]
                }
              ]
            }
          ],
          key: "formulario_envio_de_mensajes",
          coleccion: "formularios"
        }
      },
      ensayoOld: {
        status: 200,
        data: {
          variables: [
            {
              padre: "",
              nombre: "Ingreso a SAHOS1",
              lim_inferior: null,
              limites: null,
              obligatorio: false,
              tipo: "lista",
              lim_superior: null,
              grafica: null,
              key: "z8c386091a",
              valor: null,
              variable: "variable1",
              visible: true,
              lista: "Ingreso a programa SAHOS",
              opciones_lista: [
                {
                  valor: "Consulta ingreso sueño",
                  puntaje: null
                },
                {
                  valor: "Llamada ingreso sueño",
                  puntaje: null
                },
                {
                  valor: "video",
                  puntaje: null
                },
                {
                  valor: "Pendiente ingreso",
                  puntaje: null
                },
                {
                  valor: "Pendiente ingreso con orden",
                  puntaje: null
                }
              ]
            },
            {
              padre: "",
              nombre: "Ingreso a SAHOS2",
              lim_inferior: null,
              limites: null,
              obligatorio: false,
              tipo: "lista",
              lim_superior: null,
              grafica: null,
              key: "z8c386091a",
              valor: null,
              variable: "variable2",
              visible: true,
              lista: "Ingreso a programa SAHOS",
              opciones_lista: [
                {
                  valor: "Consulta ingreso sueño",
                  puntaje: null
                },
                {
                  valor: "Llamada ingreso sueño",
                  puntaje: null
                },
                {
                  valor: "Consulta médico especialista sueño",
                  puntaje: null
                },
                {
                  valor: "Pendiente ingreso",
                  puntaje: null
                },
                {
                  valor: "Pendiente ingreso con orden",
                  puntaje: null
                }
              ]
            },
            {
              padre: "",
              nombre: "Ingreso a SAHOS3",
              lim_inferior: null,
              limites: null,
              obligatorio: false,
              tipo: "lista",
              lim_superior: null,
              grafica: null,
              key: "z8c386091a",
              valor: null,
              variable: "variable3",
              visible: true,
              lista: "Ingreso a programa SAHOS",
              opciones_lista: [
                {
                  valor: "texto",
                  puntaje: null
                },
                {
                  valor: "imagen",
                  puntaje: null
                },
                {
                  valor: "video",
                  puntaje: null
                }
              ]
            },
            {
              nombre: "esta tiene padre",
              lim_inferior: null,
              limites: null,
              obligatorio: false,
              tipo: "array_lista",
              lim_superior: null,
              grafica: null,
              key: "z8c386091a",
              valor: null,
              variable: "variable4",
              visible: true,
              lista: "Ingreso a programa SAHOS",
              padre: "variable3",
              opciones_lista: [
                {
                  valor: "ejercicio brazo1",
                  puntaje: null
                },
                {
                  valor: "ejercicio pierna",
                  puntaje: null
                },
                {
                  valor: "respirar mejor",
                  puntaje: null
                },
                {
                  valor: "como estirar",
                  puntaje: null
                }
              ]
            },
            {
              nombre: "esta tambien tiene padre",
              lim_inferior: null,
              limites: null,
              obligatorio: false,
              tipo: "imagene_lista",
              lim_superior: null,
              grafica: null,
              key: "z8c386091a",
              valor: null,
              variable: "variable5",
              visible: true,
              lista: "Ingreso a programa SAHOS",
              padre: "variable4",
              opciones_lista: [
                {
                  valor:
                    "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
                  puntaje: null
                },
                {
                  valor: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
                  puntaje: null
                },
                {
                  valor: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
                  puntaje: null
                },
                {
                  valor: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
                  puntaje: null
                }
              ]
            },
            {
              padre: "",
              tipo: "string",
              lim_superior: null,
              grafica: null,
              key: "zd2a0f907a",
              valor: null,
              variable: "variable5",
              visible: true,
              lista: null,
              nombre: "Indice de ronquido PSG",
              lim_inferior: null,
              limites: null,
              obligatorio: false
            }
          ],
          key: "Base de datos SAHOS",
          coleccion: "formularios"
        },
        message: "Formulario leído"
      }
    };
  },
  beforeUpdate() {
  },
  components: {
    DatePicker,
    SerieFormularios
  },
  props: {
    terminar: {
      type: Boolean,
      default: true
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    comprobarCamposObligatorios: {
      type: Boolean,
      default: false
    },
    verCompleto: {
      type: Boolean,
      default: false
    },
    arrayCedulas: {
      type: Array,
      default: () => []
    }
  },
  async mounted() {
    await this.crearFormulario();
  },
  computed: {
    getVariablesFormularios() {
      let m_variablesFormularios = this.$store.getters.getVariablesFormulariosEnvioDeMensajes;
      const self = this;
      if (m_variablesFormularios != null) {
        m_variablesFormularios.map(variable => {
          if (variable.nombre.length >= self.valorVariable) {
            self.valorVariable = variable.nombre.length;
            if (self.valorVariable >= 22 && self.valorVariable <= 30) {
              self.gridTemplate = "1fr 1fr";
            } else if (self.valorVariable > 30) {
              self.gridTemplate = "1fr";
            } else {
              self.gridTemplate = "1fr 1fr 1fr";
            }
          }
          if (self.verCompleto === true) {
            self.gridTemplate = "1fr 1fr 1fr";
          }
        });
      }
      return m_variablesFormularios;
    }
  },
  watch: {
    comprobarCamposObligatorios(valor) {
      if (valor === true) {
        if (this.$refs.form.validate()) {
          this.$emit("cerrarSinActualizar");
        }
      }
      this.$emit("actualizarBandera");
    }
  },
  methods: {
    async crearFormulario() {
      try {
        this.$store.dispatch("setCargando", true);
        this.$store.dispatch("setVariablesFormulariosEnvioDeMensajes", null);
        this.$store.dispatch('setIdFormularioEnvioDeMensajes', null);
        const respuesta = await crearFormularioEnvioDeMensajes(
          "formulario_envio_de_mensajes",
          this.$store.state.provider_email
        );
        if (respuesta && respuesta.data && respuesta.data.data) {
          await this.consultarEstructuraFormulario(respuesta.data.data.docId, respuesta.data.data.key);
        } else {
          console.error('Error creando el formulario para envío de mensajes');
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
        this.$emit('actualizaGrafica')
      }
    },
    async consultarEstructuraFormulario(docId, tipo_esquema) {
      this.$store.dispatch('setIdFormularioEnvioDeMensajes', docId);
      const respuesta = await consultarEstructuraFormularioEnvioDeMensajes(
        tipo_esquema,
        docId
      );
      if(respuesta && respuesta.data && respuesta.data.data) {
        this.$store.dispatch("setVariablesFormulariosEnvioDeMensajes", respuesta.data.data.variables);
      }
    },
    posicionSeleccionLista(formulario, index) {
      formulario[index].seleccion = {
        lista: formulario[index].lista,
        valor: formulario[index].valor
      };
      this.$store.dispatch(
        "setVariablesFormulariosEnvioDeMensajes",
        formulario
      );
      this.construccionOpcionesLista(index);
    },
    construccionOpcionesLista(index) {
      const condiciones = this.$store.getters
        .getVariablesFormulariosEnvioDeMensajes[index].seleccion;
      const arrayVariables = this.$store.getters
        .getVariablesFormulariosEnvioDeMensajes;
      arrayVariables.map((elemento, index1) => {
        if (elemento.indexPadre === index) {
          elemento.valor = null;
          this.posicionSeleccionLista(arrayVariables, index1);
          elemento.lista_seleccionada = elemento.opciones_lista.filter(x =>
            x.condiciones.some(
              e =>
                e.lista === condiciones.lista && e.valor === condiciones.valor
            )
          );
          elemento.habilitado = this.habilitarSelect(
            elemento.lista_seleccionada
          );
        }
      });
      this.$store.dispatch(
        "setVariablesFormulariosEnvioDeMensajes",
        arrayVariables
      );
      this.renderizar += 1;
    },
    habilitarSelect(lista_seleccionada) {
      if (lista_seleccionada.length > 0) {
        return true;
      }
      return false;
    },
    nextPage(numberOfPages) {
      if (this.page + 1 <= numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    imagenSeleccionada1(imagen) {
      console.log("imagen", imagen);
    },
    cancelar() {
      this.$refs.form.reset();
      this.formularioEnviarMensaje += 1;
    },
    cerrarEnvioMensajes() {
      this.$router.push("/AnalisisDeFormulario");
      this.$emit("verBoton");
    },
    filterJsonV3(variables, filterValue, value) {
      return variables.filter(element => element[filterValue] == value);
    },
    //  Funcion para calcular el numero de opciones seleccionadas dependiendo de la cantidad del texto seleccionado
    calcularCantidadSeleccionada(arrayValores) {
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    },
    calcularNumeros(valor) {
      for (let i = 0; i <= valor; i++) {
        this.arrayNumeros.push(i.toString());
      }
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },
    fechaFormateada(index) {
      this.variablesActualizadas[index];
      this.dateFormatted = this.formatDate(this.date);
    },
    construirArrayVariablesActualizar() {
      // const validacionFormulario = this.$refs.form.validate();
      const arrayActualizar = [];
      let m_variablesFormularios = this.$store.getters.getVariablesFormulariosEnvioDeMensajes;
      m_variablesFormularios[6].valor = this.arrayCedulas;
      m_variablesFormularios.map((variable) => {
        if (variable.valor != null) {
          if (variable.tipo == "numero") {
            const jsonActualizar = {
              nombre: variable.variable,
              valor: Number(variable.valor)
            };
            arrayActualizar.push(jsonActualizar);
          } else {
            const jsonActualizar = {
              nombre: variable.variable,
              valor: variable.valor
            };
            arrayActualizar.push(jsonActualizar);
          }
        }
      });
      this.actualizarFormularioActual(arrayActualizar);
      this.$refs.form.reset();
    },
    async actualizarFormularioActual(arrayActualizar) {
      try {
        this.$store.dispatch("setCargando", true);
        let respuesta = await actualizarFormularioEnvioDeMensajes(
          'formulario_envio_de_mensajes',
          this.$store.getters.getIdFormularioEnvioDeMensajes,
          this.$store.state.provider_email,
          arrayActualizar,
        );
        if (respuesta) {
          if (respuesta.data &&  respuesta.data.data) {
            const respuestaEnvioMensajes = await enviarMensaje(respuesta.data.data.docId);
            if (respuestaEnvioMensajes) {
              this.$store.dispatch("cambiarEstadoModal", true);
              this.$store.dispatch("cambiarMensajeModal", respuestaEnvioMensajes);
            } else {
              console.error('Error en la respuesta de enviarMensaje');
            }
          }
          this.regresar();
        } else {
          console.error('Error actualizando el formulario de envío de mensajes');
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setIdFormularioEnvioDeMensajes", null);
        this.$store.dispatch("setCargando", false);
      }
    },
    async eliminarFormulario() {
      this.$store.dispatch("setCargando", true);
      const respuesta = await eliminarFormulariosExistentes(
        this.$store.getters.getIdFormulario,
        this.$store.getters.getNombreFormulario
      );
      serverBus.$emit("formularioActualizadoExitosamenteMomento", respuesta);
      this.banderaMostrarTarjetaCompleta = false;
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", respuesta);
      if (
        this.$store.getters.getBanderaFormularioCreadoPanel == false &&
        this.terminar
      ) {
        this.$store.dispatch("setMensajeChatBox", "Terminar");
      } else {
        this.$store.dispatch("setBanderaFormularioCreadoPanel", false);
      }
      serverBus.$emit("formularioActualizado", respuesta.data);
      this.regresar();
      if (!this.$store.getters.getBanderaBotonMas) {
        this.$store.dispatch("setMensajeChatBox", "Terminar");
      }
      this.$emit("formularioActualizado");
      this.$store.dispatch("setCargando", false);
    },
    regresar: function() {
      this.$store.dispatch("setVariablesFormulariosEnvioDeMensajes", []);
      this.$store.dispatch("setIdFormularioEnvioDeMensajes", null);
      this.cerrarEnvioMensajes();
    }
  }
};
</script>

<style src="./EnvioDeMensajes.scss" lang="scss" scoped></style>

<style lang="scss">
// .contenedorEnviMensajes {
//   .tituloVariable {
//     color: #666666;
//     font-size: 21px;
//     font-weight: 500;
//   }
//   .autocomplete {
//     margin-top: 12px;
//     .v-input__control {
//       .v-input__slot {
//         background-color: #f3f3f3 !important;
//         .v-select__slot {
//           input {
//             color: #2d2d2d !important;
//             font-weight: 600;
//           }
//           .mdi-menu-down::before {
//             color: #3a899a !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//     }
//   }
//   .autocomplete-llenado {
//     .v-input__control {
//       .v-input__slot {
//         background-color: #d9edf0 !important;
//         .v-select__slot {
//           input {
//             color:#575757 !important;
//             font-weight: 600;
//           }
//           .mdi-menu-down::before {
//             color: #575757 !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//     }
//   }
//   .autocomplete-deshabilitado {
//     .v-input__control {
//       .v-input__slot {
//         background-color: #f3f3f3 !important;
//         .v-select__slot {
//           input {
//             color: #2d2d2d !important;
//           }
//           .mdi-menu-down::before {
//             color: #666666 !important;
//             height: 28px;
//             font-size: 28px;
//           }
//         }
//       }
//     }
//   }
//   .contenedorImagen {
//     span {
//       width: fit-content;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/EnvioDeMensajes/EnvioDeMensajes.vue